import { context } from '@/api';
import * as types from '../../mutationTypes';

export default {
  async getAll({ commit }) {
    const responseContext = await context.getContext();

    const data = {
      context: responseContext.data
    };

    commit(types.BULK_ADD_CLIENT_CONTEXT_ITEMS, data);
  },

  async getChildContext({ commit }, key) {
    const responseContext = await context.getChildContext(key);

    const data = {
      contextChildren: responseContext.data
    };
    commit(types.GET_CHILD_CONTEXT, data);
  },

  async updateContextItem({ commit }, details) {
    const { key, ...payload } = details;

    const response = await context.updateContextItem(key, payload);
    commit(types.UPDATE_CLIENT_CONTEXT_ITEM, response.data);

    // if impactedContextKeys are returned, update the impacted context keys
    if (response.data.impactedContextKeys && response.data.impactedContextKeys.length > 0) {
      commit(types.BULK_UPDATE_IMPACTED_CLIENT_CONTEXT_ITEMS, response.data.impactedContextKeys);
    }
  },

  async updateContextItemInDatabase(_, details) {
    const { key, ...payload } = details;

    const response = await context.updateContextItem(key, payload);

    return response.data;
  },

  async bulkUpdateContextItemInStore({ commit }, details) {
    const { payload } = details;

    commit(types.BULK_UPDATE_IMPACTED_CLIENT_CONTEXT_ITEMS, payload);
  },

  async updateChildContextItem({ commit }, details) {
    const { key, ...payload } = details;

    await context.updateChildContextItem(key, payload);

    commit(types.UPDATE_CHILD_CONTEXT_ITEM, details);
  }
};
